import { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/navbar";
import Home from "./pages/home";
import Contact from "./pages/contact";
import InexoPrivacy from "./pages/inexoPrivacy";
import "./App.css";

function App() {

  const [lang, setLang] = useState("tr");

  const toggleLanguage = () => {
    setLang((prev) => (prev === "tr" ? "en" : "tr"));
  };

  return (
    <Router>
      <div className="app-container">
        <Navbar lang={lang} setLang={setLang} />
        <Routes>
          <Route path="/" element={<Home lang={lang} />} />
          <Route path="/contact" element={<Contact lang={lang} />} />
          <Route path="/inexo-finance/privacy-policy" element={<InexoPrivacy lang={lang} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;